/**
 * @flow
 * @relayHash a6d7023863d70b4f17868049d68dfa82
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailStripePaymentLinkInput = {|
  invoiceId: string,
  customerEmail?: ?string,
|};
export type EmailStripePaymentLinkMutationVariables = {|
  input: EmailStripePaymentLinkInput
|};
export type EmailStripePaymentLinkMutationResponse = {|
  +emailStripePaymentLink: {|
    +success: boolean
  |}
|};
export type EmailStripePaymentLinkMutation = {|
  variables: EmailStripePaymentLinkMutationVariables,
  response: EmailStripePaymentLinkMutationResponse,
|};
*/


/*
mutation EmailStripePaymentLinkMutation(
  $input: EmailStripePaymentLinkInput!
) {
  emailStripePaymentLink(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailStripePaymentLinkInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailStripePaymentLink",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailStripePaymentLinkPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailStripePaymentLinkMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailStripePaymentLinkMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailStripePaymentLinkMutation",
    "id": null,
    "text": "mutation EmailStripePaymentLinkMutation(\n  $input: EmailStripePaymentLinkInput!\n) {\n  emailStripePaymentLink(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ba4724b1f282b303049c675203dc373';
module.exports = node;
